import { useState } from 'react';
import { Send } from 'lucide-react';

interface NoteEditorProps {
  onSubmit: (content: string) => void;
  placeholder?: string;
  isSubmitting?: boolean;
}

export function NoteEditor({
  onSubmit,
  placeholder = 'Write a note...',
  isSubmitting = false,
}: NoteEditorProps) {
  const [content, setContent] = useState('');

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmed = content.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
    setContent('');
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={placeholder}
        rows={3}
        className="input w-full resize-none"
        disabled={isSubmitting}
      />
      <div className="flex justify-end">
        <button
          type="submit"
          disabled={!content.trim() || isSubmitting}
          className="btn-primary btn-sm"
        >
          <Send className="h-3.5 w-3.5" />
          {isSubmitting ? 'Saving...' : 'Add Note'}
        </button>
      </div>
    </form>
  );
}
